export default __webpack_public_path__ + "static/media/redsceptre-icon.5168c21c.png";